var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VCard',[_c('VCardText',[_c('div',{staticClass:"revision-mutation-title"},[_vm._v(_vm._s(_vm.index + 1)+". "+_vm._s(_vm.assetName))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }